import { useAppNavigation } from "src/contexts/AppNavigationContext";
import { FC, useEffect, useState } from "react";
import DrawerItem from "../Drawer/DrawerItem";
import { FontAwesomeIcons } from "src/constants/fontAwesomeIcons";

import "./MobileDrawer.scss";

const MobileDrawer: FC = () => {
    const { isOpen, isDesktop, drawerItems } = useAppNavigation();
    //
    // -- States --
    const [canScrollToTop, setCanScrollToTop] = useState<boolean>(false);
    const [canScrollToBottom, setCanScrollToBottom] = useState<boolean>(false);

    //
    // -- Hooks --

    // Method to render the drawer items
    const renderDrawerItems = () => {
        return drawerItems?.map((item, index) => (
            <li
                className="drawer-list-item"
                key={`list-item-${item.title}-${index}`}
            >
                <DrawerItem
                    key={`item-${item.title}-${index}`}
                    navItem={item}
                />
            </li>
        ));
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll, { passive: true });

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const handleScroll = () => {
        const position = window.scrollY;

        position > 150 ? setCanScrollToTop(true) : setCanScrollToTop(false);
        position > 250 &&
        position < document.body.scrollHeight - window.innerHeight
            ? setCanScrollToBottom(true)
            : setCanScrollToBottom(false);
    };

    return (
        <div
            className="mobile-drawer-container"
            style={{
                width: isOpen ? "240px" : "64px",
                display: !isDesktop && isOpen && drawerItems?.length > 0 ? "block" : "none",
            }}
        >
            <div
                className="mobile-drawer-fixed-container"
                style={{
                    width: isOpen ? "240px" : "0px",
                }}
            >
                <div style={{ height: "65px" }}></div>
                <ul className="drawer-list">
                    {renderDrawerItems()} {/** Drawer items */}
                </ul>
            </div>

            {/** Auto scroll nav buttons */}
            <div
                className="mobile-drawer-footer-container"
                style={{
                    width: isOpen ? "240px" : "0px",
                    overflow: "hidden",
                }}
            >
                <ul className="mobile-drawer-list">
                    <li
                        className="mobile-drawer-list-item mobile-border-top"
                        onClick={() => {
                            window.scrollTo({ top: 0, behavior: "smooth" });
                        }}
                        style={{
                            opacity: canScrollToTop ? "1" : "0",
                            display: canScrollToTop ? "flex" : "none",
                        }}
                    >
                        <DrawerItem
                            navItem={{
                                icon: FontAwesomeIcons.Duotone.ARROWUPTOLINE,
                                title: "Return to Top",
                            }}
                        />
                    </li>
                    <li
                        className="mobile-drawer-list-item mobile-border-top"
                        onClick={() => {
                            window.scrollTo({
                                top: document.body.scrollHeight,
                                behavior: "smooth",
                            });
                        }}
                        style={{
                            opacity: canScrollToBottom ? "1" : "0",
                            display: canScrollToBottom ? "flex" : "none",
                        }}
                    >
                        <DrawerItem
                            navItem={{
                                icon: FontAwesomeIcons.Duotone.ARROWDOWNTOLINE,
                                title: "Go to Bottom",
                            }}
                        />
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default MobileDrawer;
